import reactUpdate from 'immutability-helper';

import {Tag} from 'folder-items/FileConstants';
import {BenchlingAction} from 'redux-stores/Action';

import {TagsReduxActions} from './TagsReduxActions';

export interface TagsUIState {
  tagsByCid: {[cid: string]: Array<Tag>};
  connectionIdByCid: {[cid: string]: string | null | undefined};
  equipmentIdByCid: {[cid: string]: string | null | undefined};
  studyIdsByCid: {[cid: string]: Array<string>};
}

export default function reduceTagsUI(
  state: TagsUIState = {
    tagsByCid: {},
    connectionIdByCid: {},
    equipmentIdByCid: {},
    studyIdsByCid: {},
  },
  action: BenchlingAction
): TagsUIState {
  switch (action.type) {
    case TagsReduxActions.INITIAL_TAGS_SET: {
      const {cid, tags, connectionId, equipmentId, studyIds} = action;
      return reactUpdate(state, {
        tagsByCid: {[cid]: {$set: [...tags]}},
        connectionIdByCid: {[cid]: {$set: connectionId}},
        equipmentIdByCid: {[cid]: {$set: equipmentId}},
        studyIdsByCid: {[cid]: {$set: studyIds}},
      });
    }
    case TagsReduxActions.TAG_UPDATED: {
      const {cid, tagIndex, tag} = action;
      return reactUpdate(state, {tagsByCid: {[cid]: {[tagIndex]: {$merge: tag}}}});
    }
    case TagsReduxActions.CONNECTION_UPDATED: {
      const {cid, connectionId} = action;
      return {...state, connectionIdByCid: {...state.connectionIdByCid, [cid]: connectionId}};
    }
    case TagsReduxActions.EQUIPMENT_UPDATED: {
      const {cid, equipmentId, connectionId} = action;
      return {
        ...state,
        equipmentIdByCid: {...state.equipmentIdByCid, [cid]: equipmentId},
        connectionIdByCid: {...state.connectionIdByCid, [cid]: connectionId},
      };
    }
    case TagsReduxActions.STUDIES_UPDATED: {
      const {cid, studyIds} = action;
      return {...state, studyIdsByCid: {...state.studyIdsByCid, [cid]: studyIds}};
    }
    case TagsReduxActions.TAGS_RESET: {
      const {cid} = action;
      const {[cid]: _, ...newTagsByCid} = state.tagsByCid;
      const {[cid]: __, ...newConnectionIdByCid} = state.connectionIdByCid;
      const {[cid]: ___, ...newEquipmentIdByCid} = state.equipmentIdByCid;
      return {
        ...state,
        tagsByCid: newTagsByCid,
        connectionIdByCid: newConnectionIdByCid,
        equipmentIdByCid: newEquipmentIdByCid,
      };
    }
    default:
      return state;
  }
}
